import { render, staticRenderFns } from "./HomeConsultingItem.vue?vue&type=template&id=8480a8c6&scoped=true"
import script from "./HomeConsultingItem.vue?vue&type=script&lang=js"
export * from "./HomeConsultingItem.vue?vue&type=script&lang=js"
import style0 from "./HomeConsultingItem.vue?vue&type=style&index=0&id=8480a8c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8480a8c6",
  null
  
)

export default component.exports